import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../context/Authcontext";

import toast, { Toaster } from "react-hot-toast";
import api from "../../../utils/api";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";

  
  

const AddClient = ({ setModal }) => {
  const { getRoles } = useContext(AuthContext);
 
  const [roles, setRoles] = useState([]);
  const [invite, setInvite] = useState("");
  const [originalCommission, setOriginalCommission] = useState(0);
  const [remainingCommission, setRemainingCommission] = useState(0);

 const [isSidebarOpen, setIsSidebarOpen] = useState(
    !(window.innerWidth < 768)
  );
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
      const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  
    useEffect(() => {
      const handleResize = () => {
        const mobile = window.innerWidth < 768;
        setIsMobile(mobile);
  
        // On desktop, sidebar should always be "open"
        if (!mobile) {
          setIsSidebarOpen(true);
        }
      };
  
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);

  const [formData, setFormData] = useState({
    userName: "",
    password: "",
    confirmPassword: "",
    fullName: "",
    city: "",
    phone: "",
    role: "",
    commission: "",
    creditReference: "",    
    invite: "",
    logCommission: 0,
  });

  // ================= HANDLE CHANGE =================
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "commission") {
      const percent = parseFloat(value);

      if (percent > 100) {
        toast.error("commission cannot exceed 100%");
        return;
      }

      if (percent > originalCommission) {
        toast.error("Cannot give more than your available commission");
        return;
      }

      setRemainingCommission(originalCommission - percent);
    }

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // ================= SUBMIT =================
  const handleSubmit = async (e) => {
    e.preventDefault();

    const {
      userName,
      password,
      confirmPassword,
      fullName,
      city,
      phone,
      role,
    } = formData;

    if (
      !userName ||
      !password ||
      !confirmPassword ||
      !fullName ||
      !city ||
      !phone ||
      !role
    ) {
      toast.error("All fields are required!");
      return;
    }

    if (password !== confirmPassword) {
      toast.error("Passwords do not match!");
      return;
    }

    try {
      const auth = localStorage.getItem("admin");

      const response = await api.post(
        "/api/webapi/add/user",
        formData,
        {
          headers: {
            Authorization: auth,
          },
        }
      );

      if (response?.data?.status) {
        toast.success(response.data.message);
        setModal(false);
        window.location.reload();
      } else {
        toast.error(response?.data?.message);
      }
    } catch (err) {
      console.log(err);
    //   toast.error("Something went wrong");
    }
  };

  // ================= GET LOGGED USER =================
  useEffect(() => {
    const fetchUser = async () => {
      const auth = localStorage.getItem("admin");

      const res = await api.get("/api/webapi/logUser", {
        headers: { Authorization: auth },
      });

      const user = res?.data?.row[0];

      setInvite(user?.code);
      setOriginalCommission(user?.givecommission);
      setRemainingCommission(user?.givecommission);
    };

    fetchUser();
  }, []);

  useEffect(() => {
    setFormData({
      ...formData,
      invite: invite,
      logCommission: remainingCommission,
    });
  }, [invite, remainingCommission]);

  return (
    <>
      <Toaster position="top-right" />


       {/* <AdminSidebar
          isSidebarOpen={isSidebarOpen}
          toggleSidebar={toggleSidebar}
          isMobile={isMobile}
        /> */}

        {/* Header - Pass mobile info */}
        {/* <AdminHeader
          toggleSidebar={toggleSidebar}
          isSidebarOpen={isSidebarOpen}
          isMobile={isMobile}
        /> */}


   <div
  className="px-3"
  style={{
    backgroundColor: "#f9f9f9",
    padding: "15px",
    margin: "14px",
    borderRadius: "4px",
    boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.5)",
  }}
>

        <p className="text-black fs-2 fw-bold">Add Account</p>


        <form onSubmit={handleSubmit}>
          {/* PERSONAL DETAILS */}
    <div className="row">

  {/* LEFT COLUMN */}
  <div className="col-lg-6 col-12">
    <h5 className=" text-white p-2" style={{background:"#2C3E50"}}>Personal Detail</h5>

    <div className="row">
      <div className="col-md-6 mb-3">
        <label>Client Name</label>
        <input
          type="text"
          name="userName"
          className="form-control"
          placeholder="Client Name"
          value={formData.userName}
          onChange={handleChange}
        />
      </div>

      <div className="col-md-6 mb-3">
        <label>Full Name</label>
        <input
          type="text"
          name="fullName"
          placeholder="Full Name"
          className="form-control"
          value={formData.fullName}
          onChange={handleChange}
        />
      </div>

      <div className="col-md-6 mb-3">
        <label>Password</label>
        <input
          type="password"
          placeholder="Password"
          name="password"
          className="form-control"
          value={formData.password}
          onChange={handleChange}
        />
      </div>

      <div className="col-md-6 mb-3">
        <label>Confirm Password</label>
        <input
          type="password"
          name="confirmPassword"
            placeholder="Confirm Password"
          className="form-control"
          value={formData.confirmPassword}
          onChange={handleChange}
        />
      </div>

      <div className="col-md-6 mb-3">
        <label>City</label>
        <input
          type="text"
          name="city"
            placeholder="City"
          className="form-control"
          value={formData.city}
          onChange={handleChange}
        />
      </div>

      <div className="col-md-6 mb-3">
        <label>Phone</label>
        <input
          type="text"
          placeholder="Phone"
          name="phone"
          className="form-control"
          value={formData.phone}
          onChange={handleChange}
        />
      </div>
    </div>
  </div>

  {/* RIGHT COLUMN */}
  <div className="col-lg-6 col-12">
    <h5 className="text-white p-2" style={{background:"#2C3E50"}}>Account Detail</h5>

    <div className="row">
      <div className="col-md-6 mb-3">
        <label>Account Type</label>
        <select
          name="role"
          className="form-control"
          value={formData.role}
          onChange={handleChange}
        >
          <option value="">Select Account Type</option>
          <option value="client">Client</option>
          <option value="agent">Agent</option>
        </select>
      </div>

      <div className="col-md-6 mb-3">
        <label>Credit Reference</label>
        <input
          type="number"
          name="creditReference"
            placeholder="Credit Reference"
          className="form-control"
          value={formData.creditReference}
          onChange={handleChange}
        />
      </div>
    </div>
  </div>

</div>


          {/* commission */}
        {formData.role !== "client" && (
  <>
    <h5
      className="text-white p-2 mt-3"
      style={{ background: "#2C3E50" }}
    >
      Commission Settings
    </h5>

    <div
      style={{
        border: "1px solid #ddd",
        background: "#f1f1f1",
      }}
    >
      {/* UPLINE */}
      <div
        className="d-flex"
        style={{
          borderBottom: "1px solid #ddd",
          background: "#e6e6e6",
          
        }}
      >
        <div style={{ width: "30%", padding: "10px" ,borderRight:'1px solid #ccc',}}>
          Upline
        </div>
        <div style={{ width: "100%", padding: "10px" }}>
          {originalCommission}%
        </div>
      </div>

      {/* DOWNLINE */}
      <div
        className="d-flex"
        style={{
          borderBottom: "1px solid #ddd",
        }}
      >
        <div style={{ width: "30%", padding: "10px",borderRight:'1px solid #ccc', }}>
          Downline
        </div>
        <div style={{ width: "100%", padding: "5px 10px" }}>
          <input
            type="text"
            name="commission"
            value={formData.commission || ""}
            onChange={(e) => {
              const value = e.target.value ;

              if (value > originalCommission) {
                return;
              }

              setFormData({
                ...formData,
                commission: value,
              });
            }}
            className="form-control"
            style={{ height: "35px" }}
          />
        </div>
      </div>

      {/* OUR */}
      <div className="d-flex">
        <div style={{ width: "30%", padding: "10px",borderRight:'1px solid #ccc', }}>
          Our
        </div>
        <div style={{ width: "100%", padding: "10px" }}>
          {originalCommission - (formData.commission || 0)}%
        </div>
      </div>
    </div>
  </>
)}




               
  <>
    <h5
      className="text-white p-2 mt-3"
      style={{ background: "#2C3E50" }}
    >
     Parternship
    </h5>

    <div
      style={{
        border: "1px solid #ddd",
        background: "#f1f1f1",
      }}
    >
      {/* UPLINE */}
      <div
        className="d-flex"
        style={{
          borderBottom: "1px solid #ddd",
          background: "#e6e6e6",
          
        }}
      >
        <div style={{ width: "30%", padding: "10px" ,borderRight:'1px solid #ccc',}}>
          Upline
        </div>
        <div style={{ width: "100%", padding: "10px" }}>
      
        </div>
      </div>

      {/* DOWNLINE */}
      <div
        className="d-flex"
        style={{
          borderBottom: "1px solid #ddd",
        }}
      >
        <div style={{ width: "30%", padding: "10px",borderRight:'1px solid #ccc', }}>
          Downline
        </div>
        <div style={{ width: "100%", padding: "5px 10px" }}>
          <input
            type="number"
     
         
        
            className="form-control"
            style={{ height: "35px" }}
          />
        </div>
      </div>

      {/* OUR */}
      <div className="d-flex">
        <div style={{ width: "30%", padding: "10px",borderRight:'1px solid #ccc', }}>
          Our
        </div>
        <div style={{ width: "100%", padding: "10px" }}>
        </div>
      </div>
    </div>
  </>


        
          <button className="btn btn-primary w-100 mt-3">
            Create Client
          </button>
        </form>
      </div>
    </>
  );
};

export default AddClient;
